export const siteColors = {
	loginLogo: '#d939e5',
	loginBG: '#00002c',
	loginRightBG: '#000'
}; 